import { MenuRoutes } from "@/routes";
import { Toaster } from "sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();
const MenuLayout = () => {
  return (
    <main className="bg-teal-900/10 h-full w-full overflow-hidden flex flex-row">
      <QueryClientProvider client={queryClient}>
        <div className="w-full h-full flex flex-col">
          <MenuRoutes />
        </div>
        <Toaster />
      </QueryClientProvider>
    </main>
  );
};

export default MenuLayout;
